// React for Website

import React from "react";
//outsource
import { Form, Input } from "antd";

//components

const UseDetailUserName = ({ disabled }) => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------

  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  return (
    <Form.Item
      name="username"
      label="Username"
      rules={[
        {
          required: true,
          message: "Please input username",
        },
        {
          whitespace: true,
          message: "Don't leave a blank character",
        },
      ]}
    >
      <Input placeholder="Please input username" disabled={disabled} />
    </Form.Item>
  );
};

export default UseDetailUserName;
